import React from 'react';
import ManageTemplateFormItem from '../ManageTemplateFormItem';
import { TextArea } from 'neon-design-system';
import { FormControl } from '../../../utils/form.utils';

interface FormTextAreaProps {
	id: string;
	field: FormControl<string>;
	charsLimit: number;
}

const FormTextArea = ({ id, field, charsLimit }: FormTextAreaProps) => {
	const charsLeft = +((charsLimit - (field.value?.length ?? 0)).toFixed());
	const charsMessage = `${charsLeft} characters remaining`;

	return (
		<ManageTemplateFormItem>
			<TextArea
				id={id}
				fullWidth
				type="text"
				label="Description"
				error={field.showError}
				errorText={field.validationMessage}
				progressBarHelperText={charsMessage}
				autoComplete="off"
				value={field.value}
				showProgressBar={true}
				progressBarIndicator={field.value?.length}
				progressBarLimit={charsLimit}
				onBlur={field.handleBlur}
				onChange={e => {
					const val = e?.target?.value;
					if (val?.length > charsLimit) {
						return;
					}
					field.setValue(val);
				}}
			/>
		</ManageTemplateFormItem>
	);
};

export default FormTextArea;
